var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9819 5.10645V14.4002C31.9819 15.6603 31.9819 16.2903 32.2272 16.7716C32.4429 17.195 32.7871 17.5392 33.2105 17.7549C33.6918 18.0002 34.3218 18.0002 35.5819 18.0002H44.8756M31.9819 38.25H18.4819M36.4819 29.25H18.4819M45.4819 22.4735V38.7C45.4819 42.4804 45.4819 44.3705 44.7462 45.8144C44.0991 47.0845 43.0665 48.1171 41.7964 48.7643C40.3525 49.5 38.4623 49.5 34.6819 49.5H20.2819C16.5016 49.5 14.6114 49.5 13.1675 48.7643C11.8974 48.1171 10.8648 47.0845 10.2176 45.8144C9.48193 44.3705 9.48193 42.4804 9.48193 38.7V15.3C9.48193 11.5196 9.48193 9.62947 10.2176 8.18556C10.8648 6.91547 11.8974 5.88285 13.1675 5.23571C14.6114 4.5 16.5016 4.5 20.2819 4.5H27.5084C29.1594 4.5 29.9849 4.5 30.7617 4.6865C31.4505 4.85186 32.1089 5.12459 32.7129 5.49468C33.394 5.91211 33.9778 6.49582 35.1452 7.66325L42.3187 14.8368C43.4861 16.0042 44.0698 16.5879 44.4873 17.2691C44.8573 17.873 45.1301 18.5314 45.2954 19.2202C45.4819 19.997 45.4819 20.8225 45.4819 22.4735Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientReports);
export default __webpack_public_path__ + "static/media/ClientReports.e6b8c73ae7a32d38cca281f6df09b663.svg";
export { ForwardRef as ReactComponent };